import { render, staticRenderFns } from "./tutarbilgileri.vue?vue&type=template&id=33bf53a1&"
import script from "./tutarbilgileri.vue?vue&type=script&lang=js&"
export * from "./tutarbilgileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports